import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Menu, MenuItem } from "@mui/material";

import Svg from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";

const ActionsMenu = ({
  label,
  menuId,
  buttonSx,
  menuPaperSx,
  menuItemsSx,
  actions,
  anchorEl,
  setAnchorEl,
  buttonClassName = "",
}) => {
  const open = Boolean(anchorEl);
  const handleClose = () => setAnchorEl(null);
  const handleOpen = (event) => setAnchorEl(event.currentTarget);

  const handleSelect = (onClick) => {
    handleClose();
    onClick?.();
  };

  const resolvedMenuId = menuId || `${label}-menu`;

  return (
    <>
      <Button
        sx={buttonSx}
        className={buttonClassName}
        variant="contained"
        disableElevation
        onClick={handleOpen}
        aria-controls={open ? resolvedMenuId : undefined}
        aria-haspopup="true"
        aria-expanded={open}
        disabled={!actions.length}
      >
        <span className="flex-1 text-center">{label}</span>
        <ExpandMoreIcon
          style={{
            fontSize: 32,
            color: actions.length ? HNSColors.neutrals[900] : HNSColors.neutrals[500],
          }}
        />
      </Button>

      <Menu
        id={resolvedMenuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        slotProps={{
          paper: {
            sx: menuPaperSx,
          },
        }}
      >
        {actions.map((action) => (
          <MenuItem key={action.key} onClick={() => handleSelect(action.onClick)} sx={menuItemsSx}>
            <span>{action.label}</span>
            <Svg
              name={action.icon}
              color={HNSColors.primary[400]}
              sx={{ width: "16.5px", height: "16.5px" }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ActionsMenu;
